const selectorTypes = [{ label: 'Todos', value: 'all_employees' }];

const hourValues = [
  { label: '50%', value: 'fifty' },
  { label: '100%', value: 'hundred' },
  { label: '150%', value: 'hundred_and_fifty' }
];

export { hourValues, selectorTypes };
